module.exports = __webpack_public_path__ + "static/media/menu_mobile.18771428.svg";